/* ===========================================================
   CALMA ANIMALS — mikro-interakcje (progressive enhancement)
   Wszystko gated na prefers-reduced-motion. Bez JS strona
   wyglada normalnie — ten plik tylko dodaje warstwe ruchu.
   =========================================================== */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!('IntersectionObserver' in window)) return;

  /* ---------- 1. Reveal-on-scroll ---------- */
  // Selektory elementow, ktore maja wjezdzac przy wejsciu w viewport.
  var REVEAL = [
    '.calma-bigcard', '.calma-arg', '.calma-educard', '.calma-ing__item',
    '.calma-how__step', '.calma-cmp', '.calma-ing__box', '.calma-faq__item',
    '.calma-proof__card', '.calma-chooser__col', '.ca-iv-bars', '.ca-iv-film',
    '.calma-step', '.calma-ig__cell', '.calma-zz__row', '.calma-res__card', '.calma-ben__item'
  ].join(',');

  function setupReveal() {
    if (reduce) return;
    var nodes = Array.prototype.slice.call(document.querySelectorAll(REVEAL));
    if (!nodes.length) return;

    // Stagger w obrebie wspolnego rodzica (rzedy kart wjezdzaja kaskadowo).
    var groupCount = {};
    nodes.forEach(function (el) {
      var pid = (el.parentNode && el.parentNode.__caId) || 0;
      if (!pid && el.parentNode) { pid = el.parentNode.__caId = (Math.random() + 1); }
      var key = String(pid);
      var i = groupCount[key] = (groupCount[key] || 0) + 1;
      el.style.transitionDelay = Math.min((i - 1) * 70, 280) + 'ms';
      el.classList.add('ca-reveal');
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('ca-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    nodes.forEach(function (el) { io.observe(el); });

    // Safety net: gdyby IntersectionObserver nie odpalil (wolny JS, nietypowy viewport),
    // po 2.5 s odslaniamy wszystko, co wciaz czeka.
    setTimeout(function () {
      nodes.forEach(function (el) { el.classList.add('ca-in'); });
    }, 2500);
  }

  /* ---------- 2. Wykres ppm (Skladniki): wypelnienie + count-up ---------- */
  function setupBars() {
    var bars = document.querySelector('.ca-iv-bars');
    if (!bars) return;
    if (!reduce) bars.classList.add('ca-bars-anim');

    var nums = Array.prototype.slice.call(bars.querySelectorAll('.ca-iv-bars__num'));
    nums.forEach(function (n) {
      var raw = n.textContent.trim();
      // count-up tylko dla pojedynczej liczby — zakresy typu "25–50" zostają statyczne
      if (!/^[^\d]*\d+\s*$/.test(raw)) return;
      n.setAttribute('data-prefix', /^[^\d]+/.test(raw) ? raw.match(/^[^\d]+/)[0] : '');
      n.setAttribute('data-target', raw.replace(/[^\d]/g, ''));
    });

    function countUp(el) {
      if (reduce) return;
      if (!el.hasAttribute('data-target')) return;
      var target = parseInt(el.getAttribute('data-target'), 10) || 0;
      var prefix = el.getAttribute('data-prefix') || '';
      var dur = 1100, start = null;
      function step(ts) {
        if (start === null) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = prefix + Math.round(target * eased);
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = prefix + target;
      }
      requestAnimationFrame(step);
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        bars.classList.add('ca-in');
        nums.forEach(countUp);
        io.disconnect();
      });
    }, { threshold: 0.4 });
    io.observe(bars);
  }

  /* ---------- 3. Akordeon FAQ — plynne rozwijanie ---------- */
  function setupAccordion() {
    var items = document.querySelectorAll('.calma-faq__item, .calma-how__item');
    Array.prototype.forEach.call(items, function (d) {
      var summary = d.querySelector('summary');
      var body = d.querySelector('.calma-faq__a, .calma-how__a');
      if (!summary || !body || reduce) return;
      summary.addEventListener('click', function (ev) {
        ev.preventDefault();
        if (d.open) {
          body.style.height = body.scrollHeight + 'px';
          requestAnimationFrame(function () { body.style.height = '0px'; });
          var onEnd = function () { d.open = false; body.style.height = ''; body.removeEventListener('transitionend', onEnd); };
          body.addEventListener('transitionend', onEnd);
        } else {
          d.open = true;
          var h = body.scrollHeight;
          body.style.height = '0px';
          requestAnimationFrame(function () { body.style.height = h + 'px'; });
          var onEnd2 = function () { body.style.height = ''; body.removeEventListener('transitionend', onEnd2); };
          body.addEventListener('transitionend', onEnd2);
        }
      });
    });
  }

  function init() { setupReveal(); setupBars(); setupAccordion(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
